import { IModule } from 'modules/common/interfaces';

const notificationModule: IModule = {
  routes: [],
};

export default notificationModule;
